export default {
    getDefaultState() {
        return {
            loading: {
                form: false,
                formPost: false,
                passwordRules: false,
                passwordSettings: false,
                mfaSettings: false,
                securityQuestions: false,
                orgSecurityQuestions: false,
                answerSecurityQuestions: false,
                recaptcha: false
            },
            dialogVisible: {
                orgSecurityQuestions: false
            },
            hasPolicy: false,
            hasSamlProvider: false,
            settingsForm: this.getDefaultPasswordSettings(),
            settingsRules: this.getPasswordSettingRules(),
            mfaSettingsForm: this.getDefaultMfaSettings(),
            defaultMfaSettings: this.getDefaultMfaSettings(),
            valid: false,
            allAdminUsers: [],

            passwordForm: {
                email: '',
                redirectUri: '',
                password: '',
                newPassword: '',
                confirmPassword: '',
                securityQuestions: []
            },
            orgSecurityQuestionSettingsForm: this.getDefaultOrgSecurityQuestionSettingsForm(),
            orgSecurityQuestionsForm: this.getDefaultOrgSecurityQuestionsForm(),
            orgSecurityQuestions: [],
            answerSecurityQuestionsForm: {
                securityQuestions: []
            },
            redemptionToken: '',
            passwordRules: [],
            passwordIsValid: false,
            allowNativeLogin: null,
            recaptchaSiteKey: null,
            isRecaptchaValid: false
        }
    },

    getDefaultMfaResetTableState() {
        return {
            id: null,
            user_id: null,
            org_id: null,
            reset_request_dt: null,
            f_name: null,
            l_name: null,
            full_name: null,
            search: null
        };
    },

    getDefaultPasswordSettings() {
        return {
            block_direct_login: 0,
            enable_lockout: 0,
            life_in_days: 30,
            lockout_count: 8,
            maximum_length: '',
            minimum_length: 8,
            require_lowercase: 1,
            require_number: 1,
            require_symbol: 1,
            require_uppercase: 1,
            reuse_policy: 5,
            has_policy: 0,
            has_saml_provider: 0,
            reset_token_expiration: 30,
        }
    },

    getDefaultMfaSettings() {
        return {
            enabled: 0,
            required: 0,
            use_sms: 0,
            auto_reset: 0,
            admin_users_ids: [],
        }
    },

    getPasswordSettingRules() {
        return {
            minimum_length: [
                {
                    message: 'Minimum length cannot be less than 8 characters long',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        Number(value) >= 8 ? callback() : callback(new Error(rule.message));
                    }
                }
            ],
            maximum_length: [
                {
                    message: 'Maximum length cannot be more than 64 characters long',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        value = Number(value);
                        (value > -1 && value <= 64) ? callback() : callback(new Error(rule.message));
                    }
                }
            ],
            reuse_policy: [
                {
                    message: 'Re-use limit must be between 1 to 30',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        value = Number(value);
                        (value >= 1 && value <= 30) ? callback() : callback(new Error(rule.message));
                    }
                }
            ],
            life_in_days: [
                {
                    message: 'Reset period should be no less then 30 days and no more then 180 days',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        value = Number(value);
                        (value >= 30 && value <= 180) ? callback() : callback(new Error(rule.message));
                    }
                }
            ],
            lockout_count: [
                {
                    message: 'Lockout value should be 1 through 10',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        value = Number(value);
                        (value >= 1 && value <= 10) ? callback() : callback(new Error(rule.message));
                    }
                }
            ],
            reset_token_expiration: [
                {
                    message: 'Token expiration period should be no less then 15 minutes and no more then 60 minutes',
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        value = Number(value);
                        (value >= 15 && value <= 60) ? callback() : callback(new Error(rule.message));
                    }
                }
            ],
        }
    },

    getDefaultOrgSecurityQuestionSettingsForm() {
        return {
            id: null,
            requireForAllUsers: 0,
            securityQuestionsRequired: 3,
            skipsAllowed: 2,
            requireAdminApprovalForPasswordReset: 0,
            adminUserIdsForPasswordReset: [],
            passwordResetAnswersRequired : 1
        }
    },

    getDefaultOrgSecurityQuestionsForm() {
        return {
            defaultOrgSecurityQuestions: [],
            customOrgSecurityQuestions: []
        }
    }
};
